import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { CONFIRM_NOTIFICATION_OF_BASE_AMOUNT_REVISION_FORM } from 'src/constants/FormNames';
import { getList } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  changeNotificationOfBaseAmountConfirm,
  getConfirmRevisionErrors
} from 'src/reducers/reports/notificationOfBaseAmountRevisions';
import ConfirmRevisionInsideModal from '../../components/Modal/ConfirmRevisionModal';

const mapStateToProp = state => ({
  revisions: getList(REDUCER_NAME, state),
  errors: getConfirmRevisionErrors(state)
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  onSubmit: () => dispatch(changeNotificationOfBaseAmountConfirm(ownProps.yearMonth, ownProps.hideModal))
});

const ConfirmRevisionForm = reduxForm({
  form: CONFIRM_NOTIFICATION_OF_BASE_AMOUNT_REVISION_FORM
})(ConfirmRevisionInsideModal);

export default connect(mapStateToProp, mapDispatchToProp)(ConfirmRevisionForm);
